<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/pay' }">结算管理</el-breadcrumb-item>
            <el-breadcrumb-item>结算详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="order-info">
            <div class="area-title">结算详情</div>
            <div class="cell-group border">
                <div class="cell">
                    <div class="cell-title">结算状态</div>
                    <div class="cell-value">{{statusList[order.status]}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">项目名称</div>
                    <div class="cell-value">{{order.project_name}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">创建时间</div>
                    <div class="cell-value">{{order.create_time}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">服务编号</div>
                    <div class="cell-value">{{order.sub_no}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">服务人员</div>
                    <div class="cell-value">{{order.name}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">身份证号</div>
                    <div class="cell-value">{{order.idcard}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">服务金额</div>
                    <div class="cell-value">{{order.money}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">平台服务费</div>
                    <div class="cell-value">{{order.service_fee}}</div>
                </div>
            </div>
            <div class="cell-group">
                <div class="cell">
                    <div class="cell-title">支付总额</div>
                    <div class="cell-value">{{order.total}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Detail',
    data () {
        return {
            statusList: ['待企业确认用户服务', '待用户确认服务', '服务进行中', '待支付服务成果', '待平台审核服务成果', '审核失败，待重新确认', '服务成果待用户确认', '用户异议，待重新确认', '待用户申请结算', '待确认服务结算', '打款中', '打款失败，请联系客服', '重新发起打款', '已完成', '已关闭', '用户拒绝,已关闭'],
            payStatus: ['待结算', '结算成功', '结算失败'],
            order: {
                create_time: '2019-01-02 11:01:35',
                id: 4,
                money: '1500',
                order_no: '100000304897',
                project_name: '测试批量付款',
                score: 1,
                service_fee: '106.5',
                tax: '9',
                total: 1615.5
            }
        }
    },
    mounted () {
        this.getPayInfo(this.$route.query.id, this.$route.query.sub_id)
    },
    methods: {
        getPayInfo (id, sub_id) {
            this.$http.get('/api/user/account/settlementinfo', {
                params: {
                    id,
                    sub_id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.order = res.data
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    .order-info {
        margin-top: 20px;
        padding: 20px 40px;
        background-color: #fff;
    }
    .pay-form {
        width: 410px;
        margin: 53px auto;
    }
    .cell-group {
        display: flex;
        border-right: 1px solid #ebeef5;
        .cell {
            flex: 1;
            border-bottom: 1px solid #ebeef5;
            border-left: 1px solid #ebeef5;
            display: flex;
            align-items: center;
            color: #333333;
            .cell-title {
                background-color: #f5f5fa;
                width: 260px;
                padding: 17px 20px;
            }
            .cell-value {
                flex: 1;
                padding: 17px 20px;
                max-width: 50%;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
        &.border {
            border-top: 1px solid #ebeef5;
        }
    }
    .area-title {
        background-color: #fff;
        margin-left: 0;
        font-size: 16px;
        color: $--color-primary;
        font-weight: 500;
        padding-bottom: 18px;
        position: relative;
        &::before {
            content: "";
            position: absolute;
            width: 4px;
            height: 20px;
            background-color: $--color-primary;
            left: -20px;
            top: -2px;
        }
        &.in-content {
            padding-left: 40px;
            &::before {
                left: 20px;
            }
        }
    }
</style>
